import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { UmsService } from '../ums.service';

@Component({
  selector: 'app-exam-sub-data',
  templateUrl: './exam-sub-data.component.html',
  styleUrls: ['./exam-sub-data.component.scss']
})
export class ExamSubDataComponent implements OnInit {
  displayedColumns = [ 'Id', 'Exam Id', 'Exam StrId', 'Type'];
  ExamSubForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;

  examsubList: any;
  examsub: string;
  list;
  examsubform: any;
  ExamSubjectSearchForm;
  constructor(
    public umsService: UmsService,
    private fb: FormBuilder,   public router: Router,
    private route: ActivatedRoute, ) { }

  ngOnInit(): void {
    this.submitButton = true;
    this.editButton = false;
    this.getExamSubData([]);
    this.list = true;
    this.ExamSubForm = this.fb.group({
      EsId: new FormControl ('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsEmId: new FormControl ('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsStrId: new FormControl ('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsType: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsShName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsLang: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsThPr: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsOpCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsCombCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsParent: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsPrint: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsSeq: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsLevel: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsHOM: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsMarkGrd: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsCollUni: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsSpFlag: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsGrades: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsMaxMarks: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsQMarks: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsExclTot: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsACF: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsPassMarks: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsPassPC: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsExmMarks: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsExmPC: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsExmAdd: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsDistMarks: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsDistPC: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsDistRem: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsGrdPts: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsCredit: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsPartMarks: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsDeAct: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsNoComb: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsOldCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsMarksBy: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsSubTot: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsSeSr: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      Inst: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      MustPass: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsCsSelType: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      EsCsMin: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsCsMax: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      EsCoType: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
      LoginId: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
    });

    this.ExamSubjectSearchForm = this.fb.group({
      EsEmId: new FormControl (''),
      FilterType: new FormControl ('LIKE'),
    });
  }

  keypress(){
    this.umsService.searchExamSub(this.ExamSubjectSearchForm.value).subscribe(res => {
      this.examsubList = res.data;
      },(ERROR: HttpErrorResponse) => {
        this.examsubList = [];
     });
  }

  getExamSubData(e) {
    const payload = {};
    // tslint:disable-next-line:no-string-literal
    payload['EsEmId'] = e.EmCoCode;
    // tslint:disable-next-line:no-string-literal
    payload['EsStrId'] = e.EmId;
    this.umsService.getExamSub(payload).subscribe(res => {
      this.examsubList = res.data;
      // this.dataSource = new MatTableDataSource(this.facultyList);
      });
  }

  prepopulation(e) {
    const payload = {};
    // tslint:disable-next-line:no-string-literal
    payload['EsEmId'] = e.EmCoCode;
    // tslint:disable-next-line:no-string-literal
    payload['EsStrId'] = e.EmId;
    this.umsService.getExamSub(payload).subscribe((res) => {
      const data = res.data[0];
      if (res.status){
         this.editButton = true;
         this.submitButton = false;
         this.ExamSubForm = this.fb.group({
          EsId: new FormControl (data.EsId, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsEmId: new FormControl (data.EsEmId, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsStrId: new FormControl (data.EsStrId, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsType: new FormControl (data.EsType, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsCode: new FormControl (data.EsCode, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsName: new FormControl(data.EsName, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsShName: new FormControl(data.EsShName, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsLang: new FormControl(data.EsLang, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsThPr: new FormControl(data.EsThPr, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsOpCode: new FormControl(data.EsOpCode, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsCombCode: new FormControl(data.EsCombCode, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsParent: new FormControl(data.EsParent, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsPrint: new FormControl(data.EsPrint, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsSeq: new FormControl(data.EsSeq, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsLevel: new FormControl(data.EsLevel, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsHOM: new FormControl(data.EsHOM, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsMarkGrd: new FormControl(data.EsMarkGrd, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsCollUni: new FormControl(data.EsCollUni, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsSpFlag: new FormControl(data.EsSpFlag, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsGrades: new FormControl(data.EsGrades, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsMaxMarks: new FormControl(data.EmDiv, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsQMarks: new FormControl(data.EsQMarks, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsExclTot: new FormControl(data.EsExclTot, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsACF: new FormControl(data.EsACF, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsPassMarks: new FormControl(data.EsPassMarks, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsPassPC: new FormControl(data.EsPassPC, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsExmMarks: new FormControl(data.EsExmMarks, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsExmPC: new FormControl(data.EsExmPC, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsExmAdd: new FormControl(data.EsExmAdd, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsDistMarks: new FormControl(data.EsDistMarks, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsDistPC: new FormControl(data.EsDistPC, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsDistRem: new FormControl(data.EsDistRem, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsGrdPts: new FormControl(data.EsGrdPts, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsCredit: new FormControl(data.EsCredit, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsPartMarks: new FormControl(data.EsPartMarks, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsDeAct: new FormControl(data.EsDeAct, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsNoComb: new FormControl(data.EsNoComb, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsOldCode: new FormControl(data.EsOldCode, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsMarksBy: new FormControl(data.EsMarksBy, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsSubTot: new FormControl(data.EsSubTot, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsSeSr: new FormControl(data.EsSeSr, [Validators.required, Validators.pattern('^[0-9]*$')]),
          Inst: new FormControl(data.Inst, [Validators.required, Validators.pattern('^[0-9]*$')]),
          MustPass: new FormControl(data.MustPass, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsCsSelType: new FormControl(data.EsCsSelType, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          EsCsMin: new FormControl(data.EsCsMin, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsCsMax: new FormControl(data.EsCsMax, [Validators.required, Validators.pattern('^[0-9]*$')]),
          EsCoType: new FormControl(data.EsCoType, [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
          LoginId: new FormControl(data.LoginId, [Validators.required, Validators.pattern('^[0-9]*$')]),
        });
       }else{
         this.umsService.openSnackbar(res.message);
       }
     });
  }
  delete(e){
    alert('delete' + e);
  }

  submit(){
    if (this.ExamSubForm.invalid) {
      this.ExamSubForm.get('EsId').markAsTouched();
      this.ExamSubForm.get('EsEmId').markAsTouched();
      this.ExamSubForm.get('EsStrId').markAsTouched();
      this.ExamSubForm.get('EsType').markAsTouched();
      this.ExamSubForm.get('EsCode').markAsTouched();
      this.ExamSubForm.get('EsName').markAsTouched();
      this.ExamSubForm.get('EsShName').markAsTouched();
      this.ExamSubForm.get('EsLang').markAsTouched();
      this.ExamSubForm.get('EsThPr').markAsTouched();
      this.ExamSubForm.get('EsOpCode').markAsTouched();
      this.ExamSubForm.get('EsCombCode').markAsTouched();
      this.ExamSubForm.get('EsParent').markAsTouched();
      this.ExamSubForm.get('EsPrint').markAsTouched();
      this.ExamSubForm.get('EsSeq').markAsTouched();
      this.ExamSubForm.get('EsLevel').markAsTouched();
      this.ExamSubForm.get('EsHOM').markAsTouched();
      this.ExamSubForm.get('EsMarkGrd').markAsTouched();
      this.ExamSubForm.get('EsCollUni').markAsTouched();
      this.ExamSubForm.get('EsSpFlag').markAsTouched();
      this.ExamSubForm.get('EsGrades').markAsTouched();
      this.ExamSubForm.get('EsMaxMarks').markAsTouched();
      this.ExamSubForm.get('EsQMarks').markAsTouched();
      this.ExamSubForm.get('EsExclTot').markAsTouched();
      this.ExamSubForm.get('EsACF').markAsTouched();
      this.ExamSubForm.get('EsPassMarks').markAsTouched();
      this.ExamSubForm.get('EsPassPC').markAsTouched();
      this.ExamSubForm.get('EsExmMarks').markAsTouched();
      this.ExamSubForm.get('EsExmPC').markAsTouched();
      this.ExamSubForm.get('EsExmAdd').markAsTouched();
      this.ExamSubForm.get('EsDistMarks').markAsTouched();
      this.ExamSubForm.get('EsDistPC').markAsTouched();
      this.ExamSubForm.get('EsDistRem').markAsTouched();
      this.ExamSubForm.get('EsGrdPts').markAsTouched();
      this.ExamSubForm.get('EsCredit').markAsTouched();
      this.ExamSubForm.get('EsPartMarks').markAsTouched();
      this.ExamSubForm.get('EsDeAct').markAsTouched();
      this.ExamSubForm.get('EsNoComb').markAsTouched();
      this.ExamSubForm.get('EsOldCode').markAsTouched();
      this.ExamSubForm.get('EsMarksBy').markAsTouched();
      this.ExamSubForm.get('EsSubTot').markAsTouched();
      this.ExamSubForm.get('EsSeSr').markAsTouched();
      this.ExamSubForm.get('Inst').markAsTouched();
      this.ExamSubForm.get('MustPass').markAsTouched();
      this.ExamSubForm.get('EsCsSelType').markAsTouched();
      this.ExamSubForm.get('EsCsMin').markAsTouched();
      this.ExamSubForm.get('EsCsMax').markAsTouched();
      this.ExamSubForm.get('EsCoType').markAsTouched();
      this.ExamSubForm.get('LoginId').markAsTouched();
      return;
    } else {
      this.ExamSubject();
    }
  }

  ExamSubject() {
    this.submitpayload = this.ExamSubForm.value;
    this.umsService.addExamSub(this.submitpayload).subscribe(res => {
      if (res.status){
        this.umsService.openSnackbar(res.message);
        this.ngOnInit();
      } else {
        this.umsService.openSnackbar(res.message);
      }
    });
  }

  update(){
    if (this.ExamSubForm.invalid) {
      this.ExamSubForm.get('EsId').markAsTouched();
      this.ExamSubForm.get('EsEmId').markAsTouched();
      this.ExamSubForm.get('EsStrId').markAsTouched();
      this.ExamSubForm.get('EsType').markAsTouched();
      this.ExamSubForm.get('EsCode').markAsTouched();
      this.ExamSubForm.get('EsName').markAsTouched();
      this.ExamSubForm.get('EsShName').markAsTouched();
      this.ExamSubForm.get('EsLang').markAsTouched();
      this.ExamSubForm.get('EsThPr').markAsTouched();
      this.ExamSubForm.get('EsOpCode').markAsTouched();
      this.ExamSubForm.get('EsCombCode').markAsTouched();
      this.ExamSubForm.get('EsParent').markAsTouched();
      this.ExamSubForm.get('EsPrint').markAsTouched();
      this.ExamSubForm.get('EsSeq').markAsTouched();
      this.ExamSubForm.get('EsLevel').markAsTouched();
      this.ExamSubForm.get('EsHOM').markAsTouched();
      this.ExamSubForm.get('EsMarkGrd').markAsTouched();
      this.ExamSubForm.get('EsCollUni').markAsTouched();
      this.ExamSubForm.get('EsSpFlag').markAsTouched();
      this.ExamSubForm.get('EsGrades').markAsTouched();
      this.ExamSubForm.get('EsMaxMarks').markAsTouched();
      this.ExamSubForm.get('EsQMarks').markAsTouched();
      this.ExamSubForm.get('EsExclTot').markAsTouched();
      this.ExamSubForm.get('EsACF').markAsTouched();
      this.ExamSubForm.get('EsPassMarks').markAsTouched();
      this.ExamSubForm.get('EsPassPC').markAsTouched();
      this.ExamSubForm.get('EsExmMarks').markAsTouched();
      this.ExamSubForm.get('EsExmPC').markAsTouched();
      this.ExamSubForm.get('EsExmAdd').markAsTouched();
      this.ExamSubForm.get('EsDistMarks').markAsTouched();
      this.ExamSubForm.get('EsDistPC').markAsTouched();
      this.ExamSubForm.get('EsDistRem').markAsTouched();
      this.ExamSubForm.get('EsGrdPts').markAsTouched();
      this.ExamSubForm.get('EsCredit').markAsTouched();
      this.ExamSubForm.get('EsPartMarks').markAsTouched();
      this.ExamSubForm.get('EsDeAct').markAsTouched();
      this.ExamSubForm.get('EsNoComb').markAsTouched();
      this.ExamSubForm.get('EsOldCode').markAsTouched();
      this.ExamSubForm.get('EsMarksBy').markAsTouched();
      this.ExamSubForm.get('EsSubTot').markAsTouched();
      this.ExamSubForm.get('EsSeSr').markAsTouched();
      this.ExamSubForm.get('Inst').markAsTouched();
      this.ExamSubForm.get('MustPass').markAsTouched();
      this.ExamSubForm.get('EsCsSelType').markAsTouched();
      this.ExamSubForm.get('EsCsMin').markAsTouched();
      this.ExamSubForm.get('EsCsMax').markAsTouched();
      this.ExamSubForm.get('EsCoType').markAsTouched();
      this.ExamSubForm.get('LoginId').markAsTouched();
      return;
    } else {
      this.updateExamSub();
    }
  }

  updateExamSub() {
    // 403 code error handling needed to be given
    this.submitpayload = this.ExamSubForm.value;
    this.umsService.updateExamSub(this.submitpayload).subscribe(res => {
      if (res.status){
        this.umsService.openSnackbar(res.message);
        this.ngOnInit();
      } else {
        this.umsService.openSnackbar(res.message);
        this.ngOnInit();
      }
    });
  }

  addnewrecord(e){
    if (e === 'true'){
      this.list = false;
      this.ExamSubForm = this.fb.group({
        EsId: new FormControl ('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsEmId: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsStrId: new FormControl ('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsType: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsCode: new FormControl ('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsShName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsLang: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsThPr: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsOpCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsCombCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsParent: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsPrint: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsSeq: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsLevel: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsHOM: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsMarkGrd: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsCollUni: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsSpFlag: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsGrades: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsMaxMarks: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsQMarks: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsExclTot: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsACF: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsPassMarks: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsPassPC: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsExmMarks: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsExmPC: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsExmAdd: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsDistMarks: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsDistPC: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsDistRem: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsGrdPts: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsCredit: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsPartMarks: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsDeAct: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsNoComb: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsOldCode: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsMarksBy: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsSubTot: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsSeSr: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        Inst: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        MustPass: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsCsSelType: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        EsCsMin: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsCsMax: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
        EsCoType: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-Z0-9]*$')]),
        LoginId: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      });
    } else {
      this.list = true;
    }
  }

  editdata(e, k){
    if (e === 'true'){
      this.list = false;
      // this.getExamData();
      this.prepopulation(k);
    } else {
      this.list = true;
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
   }
}
